import { css } from 'styled-components';
import spacingCss from './spacing.css';

export const spacingTokens = css`
  ${spacingCss}
`;

export type Spacings =
  | 'space-00'
  | 'space-01'
  | 'space-02'
  | 'space-03'
  | 'space-04'
  | 'space-05'
  | 'space-06'
  | 'space-07'
  | 'space-08'
  | 'space-09';
